import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { SessionData, SessionDataService } from '../service/session-data.service';
import { SpinnerService } from '../../spinner-component/spinner.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-session-summary',
  templateUrl: './session-summary.component.html',
  styleUrls: ['./session-summary.component.css']
,
  standalone: false
})
export class SessionSummaryComponent implements OnChanges, AfterViewInit {
  @Input() selectedTab: any;
 @ViewChild('tabGroup') tabGroup!: MatTabGroup;
 @Output() tabSwitch = new EventEmitter<number>();
  // totalSessions: number;
  // activeSessions: number;
  //uniqueActive: number;
  activeUsers: number;
  timeRange: string = 'month';
  internalUsers: number;
  externalUsers: number; 
  // allInternalUsers: number;
  // allExternalUsers: number; 
  activeUniqueUsernames: number;
  isInitialLoad: boolean = true;
  startDate: Date | null = null;
  endDate: Date | null = null;
  metricData: any = {};


    // Example data
    totalSessions: number = 100;
    activeSessions: number = 50;
    uniqueActive: number = 80;
    allInternalUsers: number = 30;
    allExternalUsers: number = 20;
  
    // Data source for mat-table
    dataSource = new MatTableDataSource<any>([]);
    instantDS= new MatTableDataSource<any>([]);

    // Displayed columns
    displayedColumns: string[] = ['category', 'totalCount', 'uniqueCount'];
  fromDate: any;
  toDate: any;

  constructor(private sessionDataService: SessionDataService,private router: Router,
    private spinner: SpinnerService, private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.isInitialLoad && this.selectedTab == '0') {
        this.applyFilter();
    }
  }

  ngAfterViewInit(){
       const storedTab = localStorage.getItem('selectedTab');
  if (storedTab !== null) {
    this.selectedTab = +storedTab; 
  }
  }

  ngOnChanges(changes: any): void {
    if (!changes.selectedTab || String(changes.selectedTab.currentValue) !== '0') {
      return;
    }

    const previousTab = changes.selectedTab.previousValue;
    if (previousTab !== undefined && previousTab !== null && String(previousTab) !== '0') {
      this.resetDashboardFilters();
    }

    this.applyFilter();
    this.isInitialLoad = false;
  }

  resetDashboardFilters(): void {
    this.timeRange = 'month';
    this.startDate = null;
    this.endDate = null;
  }

 routeToSessionPage(row: any): void {
  const filters: any = {};
  switch (row.category) {
    case 'PV Users':
      filters.pv = 'true';
      break;
    case 'Non-PV Users':
      filters.pv = 'false';
      break;
    case 'Active Users':
      filters.userState = 'Active';
      break;
    case 'Web Logins':
      filters.source = 'web';
      break;
    case 'Android Logins':
      filters.source = 'android';
      break;
    case 'iOS Logins':
      filters.source = 'ios';
      break;
    case 'KME Logins':
      filters.keepLogin = 'true';
      break;
    case 'Total Sessions': 
      filters.totalCount = 'true';
      break;
    default:
      return; 
  }
 
  filters.timeRange = 'month'; 
  localStorage.setItem('userSessionFilters', JSON.stringify(filters));
  this.tabSwitch.emit(1);
}

  convertDurationToHours(streamDuration) {
    let totalSeconds = 0;
    const durationsInHours:any = {};

    for (let key in streamDuration) {
        const hours = (streamDuration[key] / 60).toFixed(2); // Convert seconds to hours and round to 2 decimal places
        durationsInHours[key] = `${hours} h`;
        totalSeconds += streamDuration[key];
    }

    const totalHours = (streamDuration.total / 60).toFixed(2);
    durationsInHours.total = `${totalHours} h`;

    return durationsInHours;
  }

  formatNumber(value: number): string {
    if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + 'M'; // Convert to millions
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2) + 'K'; // Convert to thousands
    } else {
      return value.toString(); // Keep as-is for smaller numbers
    }
  }
  updateSummary(fromDate: string, toDate: string) {
    const payload = {
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.activate();
    this.sessionDataService.getHistorySummaryMetrics(payload).subscribe(data => {
      data.combinedStreamDuration = {
        total: data.streamDuration.total + data.streamDuration_customer.total,
        web: data.streamDuration.web + data.streamDuration_customer.web,
        android: data.streamDuration.android + data.streamDuration_customer.android,
        ios: data.streamDuration.ios + data.streamDuration_customer.ios,
      };
      data.streamDuration = this.convertDurationToHours(data.combinedStreamDuration);

      if (data?.totalRequests?.total && data?.totalRequests_customer?.total) {
        data.combinedTotalRequests = {
          total: data.totalRequests.total + data.totalRequests_customer.total,
          web: data.totalRequests.web + data.totalRequests_customer.web,
          android: data.totalRequests.android + data.totalRequests_customer.android,
          ios: data.totalRequests.ios + data.totalRequests_customer.ios,
        };
      }

      if (data?.footagesDownloaded?.total && data?.footagesDownloaded_customer?.total) {
        data.footagesDownloaded = {
          total: data.footagesDownloaded.total + data.footagesDownloaded_customer.total,
          web: data.footagesDownloaded.web + data.footagesDownloaded_customer.web,
          android: data.footagesDownloaded.android + data.footagesDownloaded_customer.android,
          ios: data.footagesDownloaded.ios + data.footagesDownloaded_customer.ios,
        };
      }

      data.totalRequests.total = this.formatNumber(data?.combinedTotalRequests.total);
      data.totalRequests.web = this.formatNumber(data?.combinedTotalRequests.web);
      this.dataSource = new MatTableDataSource<any>([
        { category: 'Total Sessions', uniqueCount: data.uniqueData.totalSessions, totalCount: data.nonUniqueData.totalSessions },
        { category: 'Active Users', uniqueCount: '-', totalCount: data.activeUsers },
        { category: 'PV Users', uniqueCount: data.uniqueData.pvUsers, totalCount: data.nonUniqueData.pvUsers },
        { category: 'Non-PV Users', uniqueCount: data.uniqueData.nonPvUsers, totalCount: data.nonUniqueData.nonPvUsers },
        // { category: 'Customer Logins', uniqueCount: data.uniqueData.customerLogins, totalCount: data.nonUniqueData.customerLogins },
        { category: 'Web Logins', uniqueCount: data.uniqueData.webLogins, totalCount: data.nonUniqueData.webLogins },
        { category: 'Android Logins', uniqueCount: data.uniqueData.androidLogins, totalCount: data.nonUniqueData.androidLogins },
        { category: 'iOS Logins', uniqueCount: data.uniqueData.iosLogins, totalCount: data.nonUniqueData.iosLogins },
        { category: 'KME Logins', uniqueCount: data.uniqueData.kmeLogins, totalCount: data.nonUniqueData.kmeLogins },
        { category: 'Footages Downloaded', uniqueCount: '-', totalCount: '', split: 'true', data: data.footagesDownloaded },
        { category: 'Live Views', uniqueCount: '-', totalCount: '', split: 'true', data: data.liveViews },
        { category: 'Stream Duration', uniqueCount: '-', totalCount: '', split: 'true', data: data.streamDuration },
        { category: 'SD Requests', uniqueCount: '-', totalCount: '', split: 'true', data: data.totalRequests }

      ]);
      setTimeout(()=> {
        this.spinner.deactivate();
      }, 2000);
    });
    this.sessionDataService.getInstantMetrics(payload).subscribe(data => {
      data.combinedStreamDuration = {
        total: data.streamDuration.total + data.streamDuration_customer.total,
        web: data.streamDuration.web + data.streamDuration_customer.web,
        android: data.streamDuration.android + data.streamDuration_customer.android,
        ios: data.streamDuration.ios + data.streamDuration_customer.ios,
      };
      data.streamDuration = this.convertDurationToHours(data.combinedStreamDuration);

      if (data?.totalRequests?.total && data?.totalRequests_customer?.total) {
        data.combinedTotalRequests = {
          total: data.totalRequests.total + data.totalRequests_customer.total,
          web: data.totalRequests.web + data.totalRequests_customer.web,
          android: data.totalRequests.android + data.totalRequests_customer.android,
          ios: data.totalRequests.ios + data.totalRequests_customer.ios,
        };
      }

      if (data?.footagesDownloaded?.total && data?.footagesDownloaded_customer?.total) {
        data.footagesDownloaded = {
          total: data.footagesDownloaded.total + data.footagesDownloaded_customer.total,
          web: data.footagesDownloaded.web + data.footagesDownloaded_customer.web,
          android: data.footagesDownloaded.android + data.footagesDownloaded_customer.android,
          ios: data.footagesDownloaded.ios + data.footagesDownloaded_customer.ios,
        };
      }

      data.totalRequests.total = this.formatNumber(data?.combinedTotalRequests.total);
      data.totalRequests.web = this.formatNumber(data?.combinedTotalRequests.web);
      this.instantDS = new MatTableDataSource<any>([
        { category: 'Total Sessions', uniqueCount: data.uniqueData.totalSessions, totalCount: data.nonUniqueData.totalSessions },
        { category: 'Active Users', uniqueCount: '-', totalCount: data.activeUsers },
        { category: 'PV Users', uniqueCount: data.uniqueData.pvUsers, totalCount: data.nonUniqueData.pvUsers },
        { category: 'Non-PV Users', uniqueCount: data.uniqueData.nonPvUsers, totalCount: data.nonUniqueData.nonPvUsers },
        // { category: 'Customer Logins', uniqueCount: data.uniqueData.customerLogins, totalCount: data.nonUniqueData.customerLogins },
        { category: 'Web Logins', uniqueCount: data.uniqueData.webLogins, totalCount: data.nonUniqueData.webLogins },
        { category: 'Android Logins', uniqueCount: data.uniqueData.androidLogins, totalCount: data.nonUniqueData.androidLogins },
        { category: 'iOS Logins', uniqueCount: data.uniqueData.iosLogins, totalCount: data.nonUniqueData.iosLogins },
        { category: 'KME Logins', uniqueCount: data.uniqueData.kmeLogins, totalCount: data.nonUniqueData.kmeLogins },
        { category: 'Footages Downloaded', uniqueCount: '-', totalCount: '', split: 'true', data: data.footagesDownloaded },
        { category: 'Live Views', uniqueCount: '-', totalCount: '', split: 'true', data: data.liveViews },
        { category: 'Stream Duration', uniqueCount: '-', totalCount: '', split: 'true', data: data.streamDuration },
        { category: 'SD Requests', uniqueCount: '-', totalCount: '', split: 'true', data: data.totalRequests }
      ]);
      setTimeout(()=> {
        this.spinner.deactivate();
      }, 2000);
    });

    // this.sessionDataService.getSessions().subscribe((sessions: any) => {
    //     let allSessions = sessions?.content;
    //     this.totalSessions = allSessions.length;
    //     let activeSessions = allSessions.filter(session => !session.logoutTimeInIST);
    //     this.activeSessions = activeSessions.length;
    //     const uniqueUsernames = allSessions
    //     .reduce((uniqueUsernames, session) => {
    //       if (!uniqueUsernames.includes(session.username)) {
    //         uniqueUsernames.push(session.username);
    //       }
    //       return uniqueUsernames;
    //     }, []);
        
    //     this.uniqueActive = uniqueUsernames.length;

    //     const allInternalUsers = uniqueUsernames.filter(userName => userName.endsWith('@pro-vigil.com') || !userName.includes('@'));
    //     this.allInternalUsers = allInternalUsers.length;

    //     const allExternalUsers = uniqueUsernames.filter(userName => !userName.endsWith('@pro-vigil.com') && userName.includes('@'));
    //     this.allExternalUsers = allExternalUsers.length;
    // });

    /*this.sessionDataService.getActiveSessions().subscribe((sessions: any) => {
        // console.log(sessions);
        // const uniqueUsernames = sessions
        // .filter(session => !session.logoutTimeInIST)
        // .reduce((uniqueUsernames, session) => {
        //   if (!uniqueUsernames.includes(session.username)) {
        //     uniqueUsernames.push(session.username);
        //   }
        //   return uniqueUsernames;
        // }, []);
        
        // console.log(uniqueUsernames);
        const internalUsers = sessions.content.filter(session => session.username.endsWith('@pro-vigil.com') || !session.username.includes('@'));
        this.internalUsers = internalUsers.length;

        const externalUsers = sessions.content.filter(session => !session.username.endsWith('@pro-vigil.com') && session.username.includes('@'));
        this.externalUsers = externalUsers.length;

        this.activeUsers = sessions.content.length;
        const activeUniqueUsernames = sessions.content.reduce((uniqueUsernames, session) => {
            if (!uniqueUsernames.includes(session.username)) {
                uniqueUsernames.push(session.username);
            }
            return uniqueUsernames;
          }, []);
        this.activeUniqueUsernames = activeUniqueUsernames.length;
    }); */
  }
  onTimeRangeChange(event?: { value: string }) {
    if (event?.value) {
      this.timeRange = event.value;
    }
    if (this.timeRange !== 'custom') {
      this.applyFilter();
    }
  }

  onCustomDateChange() {
    if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      this.applyFilter();
    }
  }
  applyFilter(): void {
    let fromDate: string;
    let toDate: string;
    const currentDate = new Date();
    
    if (this.timeRange === 'day') {
      fromDate = this.formatDateToLocal(currentDate, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
      this.updateSummary(fromDate, toDate);
    } else if (this.timeRange === 'week') {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
      fromDate = this.formatDateToLocal(startOfWeek, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
      this.updateSummary(fromDate, toDate);
    } else if (this.timeRange === 'month') {
      const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      fromDate = this.formatDateToLocal(startOfMonth, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
      this.updateSummary(fromDate, toDate);
    } else if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      fromDate = this.customFormatDate(this.startDate);
      toDate = this.customFormatDate(this.endDate);
      this.updateSummary(fromDate, toDate);
    } 
    /*else {
      fromDate = this.formatDate(currentDate);
      toDate = this.formatEndDate(currentDate);
    }*/
  }

  customFormatDate(momentDate: any): string {
    const formattedDate =  momentDate.format('YYYY-MM-DD HH:mm:ss');
    return formattedDate;
  }

  formatDate(date: Date): string {
    const localDateString = date.toLocaleDateString('en-US');
    return localDateString.split('T')[0] + ' 00:00:00';
  }

  formatDateToLocal(date: Date, perfix: string): string {
    const localDate = new Date(date.getTime());
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}-${month}-${day} ${perfix}`;
  
    return formattedDate;
  }
  

  formatEndDate(date: Date): string {
    return date.toISOString().split('T')[0] + ' 23:59:59';
  }
}
